// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bcd6e717326d750a0828","655":"1f8a0a3100dd3de23a34"}[chunkId] + ".js";
};